import { createFileRoute } from "@tanstack/react-router";
import { Support } from "@/pages/support/Support";

export const Route = createFileRoute("/_app/support/")({
	head: () => ({
		meta: [{ title: "Support - Biteasy" }],
	}),
	component: RouteComponent,
});

function RouteComponent() {
	return <Support />;
}
